namespace SPA
{
	export namespace Organization
	{
		export namespace gui
		{
			export class CompanyConfigEntry extends AbstractEntry
			{

				private m_Company: Wollmilch.CompanyObject;

				public constructor( obj: Wollmilch.CompanyObject, orga: OrgaTree )
				{
					super( orga );

					this.m_Company = obj;

					this.clearTitle();
					this.addTitle( 'Einstellungen' );
				}

				public rebuild( root?: ui.base.BaseHTMLElement<HTMLElement> | JQuery<HTMLElement> ): CompanyConfigEntry
				{
					super.rebuild( root );

					this.buildLayout();

					return this;
				}

				private buildLayout(): void
				{
					return;
				}

			}
		}
	}
}
